export const UPDATE_FEATURE_TOGGLE_STATS_REQUEST = 'UPDATE_FEATURE_TOGGLE_STATS_REQUEST';
export const UPDATE_FEATURE_TOGGLE_STATS_SUCCESS = 'UPDATE_FEATURE_TOGGLE_STATS_SUCCESS';
export const UPDATE_FEATURE_TOGGLE_STATS_FAILURE = 'UPDATE_FEATURE_TOGGLE_STATS_FAILURE';
